export default __webpack_public_path__ + "static/media/ic-chapter-test.e9671840.svg";